import BaseAPIService from '@/services/baseAPIService'

export default class UserAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Users
  getUser(id) { return this.httpClient.get(`/users/${id}`) } 
  getUserList() { return this.httpClient.get('/users') }
  createUser(data) { return this.httpClient.post('/users', data) }
  updateUser(id, data) { return this.httpClient.put(`/users/${id}`, data) }
  archiveUser(id) { return this.httpClient.put(`/users/${id}/archive`) }
  restoreUser(id) { return this.httpClient.put(`/users/${id}/restore`) }
  updateUserPermissions(id, data) { return this.httpClient.put(`/users/${id}/permissions`, data) }
  resetUserPermissions(id) { return this.httpClient.delete(`/users/${id}/permissions`) }

  // Current user
  updateCurrentUserPassword(data) { return this.httpClient.put(`/users/current/password`, data) }

  // User Groups
  getUserGroupList() { return this.httpClient.get('/usergroups') }
  getUserGroup(id)  { return this.httpClient.get(`/usergroups/${id}`) } 
  createUserGroup(data) { return this.httpClient.post('/usergroups', data) }
  updateUserGroup(id, data) { return this.httpClient.put(`/usergroups/${id}`, data) }
  deleteUserGroup(id) { return this.httpClient.delete(`/usergroups/${id}`) }
  updateUserGroupPermissions(id, data) { return this.httpClient.put(`/usergroups/${id}/permissions`, data) }
  resetUserGroupPermissions(id) { return this.httpClient.delete(`/usergroups/${id}/permissions`) }

  // User - MFA
  requestUserMFASecret()    { return this.httpClient.post('/users/current/mfa/request') }
  disableUserMFA(data)      { return this.httpClient.post('/users/current/mfa/disable', data) }
  enableUserMFA(data)       { return this.httpClient.post('/users/current/mfa/enable', data) }

  disableOtherUserMFA(userId, data)      { return this.httpClient.post(`/users/${userId}/mfa/disable`, data) }
  
}
